export default __webpack_public_path__ + "static/media/kidney.a0742d8b.svg";